/**
 * index.js
 */ var $96da81c2977d8a81$exports = {};
$96da81c2977d8a81$exports = JSON.parse("{\"name\":\"Nayeon\",\"text\":\"Santa, tell me if you're really there Don't make me fall in love again if he won't be here Next year Santa, tell me if he really cares 'Cause I can't give it all away if he won't be here Next year Feeling Christmas all around And I'm tryin' to play it cool But it's hard to focus when I see him walking 'cross the room 'Let It Snow' is blasting out But I won't get in the mood I'm avoiding every mistletoe until I know It's true love that he thinks of So next Christmas I'm not all alone, boy Santa, tell me if you're really there Don't make me fall in love again if he won't be here Next year Santa, tell me if he really cares 'Cause I can't give it all away if he won't be here Next year I've been down this road before Fell in love on Christmas night But on New Year's Day I woke up and he wasn't by my side Now I need someone to hold Be my fire in the cold But it's hard to tell if this is just a fling Or if it's true love that he thinks of So next Christmas I'm not all alone, boy Santa, tell me if you're really there Don't make me fall in love again if he won't be here Next year Santa, tell me if he really cares 'Cause I can't give it all away if he won't be here Next year Oh, I wanna have him beside me like oh-oh-oh On the 25th by the fireplace, oh-oh-oh But I don't want a new broken heart This year I've got to be smart Oh, baby (Santa tell me) If ya won't be, (Santa tell me) if ya won't be here! (Santa tell me) Santa, tell me if you're really there (If you're really there) Don't make me fall in love again if he won't be here Next year (He won't be here next year) Santa, tell me if he really cares (Tell me babe) 'Cause I can't give it all away if he won't be here Next year (He won't be here next year) Santa, tell me if you're really there (Tell me) (Tell me baby) Don't make me fall in love again if he won't be here Next year (If he won't be, if he won't be here) Santa, tell me if he really cares (Tell me) (Do you care) 'Cause I can't give it all away if he won't be here (He won't be here next year) Next year.\"}");


/**
 * main.js
 */ /**
 * Uses `canvas.measureText` to compute and return the width of
 * the given `text` of given font in pixels.
 *
 * @param {String} text
 * The text to be rendered.
 *
 * @param {String} font
 * The CSS font descriptor that `text` is to be rendered
 * with (e.g. `bold 14px verdana`).
 *
 * @return {number} Text width
 *
 * @see https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
 */ const $54b47fc030b7b21e$export$37827d046293d309 = (text, font)=>{
    // Re-use canvas object for better performance
    const canvas = $54b47fc030b7b21e$export$37827d046293d309.canvas || ($54b47fc030b7b21e$export$37827d046293d309.canvas = document.createElement('canvas'));
    const context = canvas.getContext('2d');
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
};
/**
 * Calculates the average character width of a particular font style.
 *
 * @param {String} font
 * The CSS font descriptor that a character is to be rendered
 * with (e.g. `bold 14px verdana`).
 *
 * @return {number} Average font style character width
 */ const $54b47fc030b7b21e$var$getFontTextWidthAverage = (font)=>{
    // Test characters
    const chars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ .,\'()?!"';
    let totalWidth = 0;
    let count = 0;
    for (const char of chars){
        totalWidth += $54b47fc030b7b21e$export$37827d046293d309(char, font);
        count++;
    }
    return Math.floor(totalWidth / count);
};
const $54b47fc030b7b21e$var$getStyle = (element, prop)=>window.getComputedStyle(element, null).getPropertyValue(prop);
const $54b47fc030b7b21e$var$getFontDescriptors = (element = document.body)=>{
    const fontWeight = $54b47fc030b7b21e$var$getStyle(element, 'font-weight') || 'normal';
    const fontSize = $54b47fc030b7b21e$var$getStyle(element, 'font-size') || '16px';
    const fontFamily = $54b47fc030b7b21e$var$getStyle(element, 'font-family') || 'Times New Roman';
    return `${fontWeight} ${fontSize} ${fontFamily}`;
};
const $54b47fc030b7b21e$export$b2dc860845ffd96e = (percent = 100)=>{
    if (percent < 1 || percent > 100) throw new Error('Invalid fill percentage!');
    const textPortrait = document.getElementById('text');
    const fontSize = parseInt($54b47fc030b7b21e$var$getStyle(textPortrait, 'font-size').match(/\d+/)[0]);
    const maxLineY = Math.floor(window.innerHeight / fontSize * (percent / 100));
    const maxCharX = Math.floor(window.innerWidth / ($54b47fc030b7b21e$var$getFontTextWidthAverage($54b47fc030b7b21e$var$getFontDescriptors(textPortrait)) - 1));
    return Math.ceil(maxCharX * maxLineY);
};


const $35da740d59af89ba$var$textCount = $96da81c2977d8a81$exports.text.length;
const $35da740d59af89ba$var$textPortrait = document.getElementById('text');
const $35da740d59af89ba$var$title = document.createElement('title');
$35da740d59af89ba$var$title.textContent = `${$96da81c2977d8a81$exports.name} | CSS Text Portrait`;
document.head.appendChild($35da740d59af89ba$var$title);
const $35da740d59af89ba$var$setText = ()=>{
    const maxChar = (0, $54b47fc030b7b21e$export$b2dc860845ffd96e)();
    // apply correct repeat count to text
    $35da740d59af89ba$var$textPortrait.textContent = `${$96da81c2977d8a81$exports.text} `.repeat(Math.ceil(maxChar / $35da740d59af89ba$var$textCount)).substring(0, maxChar + 1);
};
window.addEventListener('load', $35da740d59af89ba$var$setText);
// dynamically set text on resize/zoom to ensure
// the entire viewport is covered with text
window.addEventListener('resize', $35da740d59af89ba$var$setText);


//# sourceMappingURL=css-text-portrait-builder.5afa06d9.js.map
